module.exports = __webpack_public_path__ + "img/atsushi-pro.715afedc.jpg";